// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5c14b409","453":"8f35106d","732":"0bb95994","977":"e9daa8e5"}[chunkId] + ".chunk.js";
};